import { useKeycloak } from "@react-keycloak/web";
import { ENDPOINT_BASE } from "../../api";
import { useMyHookGetEntityById } from "../myHooks";

export function useQueryGetUserByKeycloakId() {
  const { keycloak } = useKeycloak();
  const keycloakId = keycloak?.tokenParsed?.sub || null;

  const apiConfig = {
    endpoint: ENDPOINT_BASE.USER + "/keycloakId",
    queryKeyLabel: "user",
    queryKeyId: keycloakId,
    enabledParam: keycloakId,
    retry: 2,
    staleTime: 0,
  };

  const { data, isLoading, isError, isSuccess } = useMyHookGetEntityById({
    apiConfig,
  });

  const output = data?._embedded?.userList?.[0] || {};
  return {
    data: output,
    userId: output?.id || null,
    isLoading,
    isError,
    isSuccess,
  };
}
